import axios from "axios";

export const GET_ALL = "cells";


export let getAllCells = function (status) {
  return axios.get(`${GET_ALL}`);
}